module.exports = __webpack_public_path__ + "img/oa.75da9a9d.jpg";